<template>
  <el-dialog title="Lieferanten" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <product-suppliers-table
          :suppliers="product ? product.suppliers : []"
          @deleteProductSupplier="$emit('deleteProductSupplier', $event)"
        />
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import ProductSuppliersTable from './product-suppliers-table'

export default {
  components: { [Dialog.name]: Dialog, ProductSuppliersTable },
  props: ['show', 'product']
}
</script>

<style>
</style>
